/* eslint-disable no-unused-vars */
import React from 'react'
import { Input, Row, Select } from 'antd'
import { useTranslation } from 'next-i18next'
import { SearchOutlined } from '@ant-design/icons'
import { CustomCol, CustomTitle } from 'src/components'
import styles from './AdminSaleOfferListHeader.module.scss'
import { AdminSaleOfferFilterState, AdminSaleOfferStatus } from 'src/core/models'

interface AdminSaleOfferListHeaderProps {
  length: number
  filters: AdminSaleOfferFilterState
  updateState: (values: AdminSaleOfferFilterState) => void
}

const AdminSaleOfferListHeader: React.FC<AdminSaleOfferListHeaderProps> = (props) => {
  const { t } = useTranslation()
  const { length, filters, updateState } = props

  return <Row>
    <CustomCol>
      <CustomTitle label={t('SalesOffer.OfferLength', { length })} />
    </CustomCol>
    <CustomCol lg={8}>
      <Input
        onChange={(e) => updateState({ ...filters, text: e.target.value })}
        value={filters.text}
        placeholder={t('Withdrawals.Filter')}
        prefix={<SearchOutlined />}
        allowClear
      />
    </CustomCol>
    <CustomCol lg={4}>
      <Select
        value={filters.status}
        onChange={(value: AdminSaleOfferStatus) => updateState({ ...filters, status: value })}
        className={styles.selector}
      >
        <Select.Option value={'all'}>{t('Validate.AllStatus')}</Select.Option>
        <Select.Option value={'open'}>{t('SalesOffer.open')}</Select.Option>
        <Select.Option value={'accepted'}>{t('SalesOffer.accepted')}</Select.Option>
        <Select.Option value={'rejected'}>{t('SalesOffer.rejected')}</Select.Option>
        <Select.Option value={'expired'}>{t('SalesOffer.expired')}</Select.Option>
      </Select>
    </CustomCol>
  </Row>
}

export default AdminSaleOfferListHeader
